export default "__VITE_ASSET__dd2898e4__"